import type { RepositoryHttp } from "@/infrastructure/repositories/http";
import type { IRoutes } from "@/types/src/backend/routes";

type RouteType = IRoutes.Endpoints.Expert.Jobs.GetJobFinalizadaById;
type Output = RouteType["outputData"];
type URL = RouteType["url"];

export class UseCaseGetFinishedJobById {
  constructor(private readonly repository: RepositoryHttp) {}

  public run = async (jobId: string) => {
    const url: URL = `/expert/job/${jobId}/finalizada` as URL;

    const result = await this.repository.findOne<Output>(String(url));

    return result;
  };
}
